import { useTableState } from '../../Table/useTableState/useTableState';
/**
 * The List persistence hook.
 */
export const useListState = listPreference => {
  const {
    preference: tablePreference,
    dispatch,
    setFreezeColumn,
    setOrderedColumnKeys,
    setResizedColumn,
    setFreezeColumnCount,
    ...listState
  } = useTableState(listPreference);
  const {
    frozenColumnCount,
    resizedColumns,
    orderedColumnKeys,
    ...preference
  } = tablePreference;
  return {
    preference,
    ...listState
  };
};
//# sourceMappingURL=useListState.js.map